import { isArray, isEmpty } from 'lodash-es'
import { match } from 'path-to-regexp'

import { isNilOrEmptyString } from './helper'

export const getURLWithParams = (
  url: string,
  params: Record<string, unknown>,
) => {
  const searchParams = new URLSearchParams()

  Object.entries(params).forEach(([key, value]) => {
    if (isNilOrEmptyString(value)) return
    if (isArray(value) && isEmpty(value)) return

    searchParams.set(key, String(value))
  })

  const queryString = searchParams.toString()

  return queryString ? `${url}?${queryString}` : url
}

export const isMatch = (pathname: string, urls: string[]) => {
  return urls.some(url => !!match(url)(pathname))
}
